export default "__VITE_ASSET__CmghDiR0__"